import { SourcingStats } from 'api-clients/monolith';

import { Progress } from '@/components/ui/progress';
import { Typography, TypographyVariant } from '@/components/ui/typography';
import { getProgress } from '@/utils/progress';

interface ApplicantStatsProps {
  stats: SourcingStats;
  typographyVariant?: TypographyVariant;
  showOnlyActual?: boolean;
  showProgress?: boolean;
}

export function ApplicantStats({
  stats,
  typographyVariant = 'text',
  showOnlyActual = false,
  showProgress = false,
}: ApplicantStatsProps) {
  const { expected, actual } = stats;
  const progress = getProgress(expected, actual);

  const renderActual = () => {
    return <Typography variant={typographyVariant}>{actual ?? '-'}</Typography>;
  };

  if (showOnlyActual) return renderActual();

  return (
    <>
      <Typography variant={typographyVariant}>
        {actual ?? '-'} / {expected ?? '-'}
      </Typography>
      {showProgress && <Progress value={progress} />}
    </>
  );
}
